import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Spinner from 'components/Spinner';
import useInitializeApp from 'hooks/useInitializeApp';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';

export default function withLoadingScreen(WrappedComponent) {
  return function AppContent(wrappedComponentProps) {
    const [isInitializing, initializeApp] = useInitializeApp();
    const { isInitialised } = useSelector((state) => state.ui);

    useEffect(() => {
      if (window.location.pathname !== ROUTES_SELF_SERVICE.LOGIN) {
        // remove this for now as it is causing conflicting redux states and i don't think its needed
        // initializeApp();
      }
    }, [initializeApp]);

    /* eslint-disable react/jsx-props-no-spreading */
    if (isInitialised) return <WrappedComponent {...wrappedComponentProps} />;

    /* eslint-disable react/jsx-props-no-spreading */
    return isInitializing &&
      window.location.pathname !== ROUTES_SELF_SERVICE.LOGIN &&
      window.location.pathname !== ROUTES_SELF_SERVICE.SSOLOGINSUCCESS &&
      window.location.pathname !== ROUTES_SELF_SERVICE.SSOLOGINFAIL &&
      window.location.pathname !== ROUTES_SELF_SERVICE.PAYMENTSTATUSNOSESSION ? (
      <Spinner className="h-screen" />
    ) : (
      <WrappedComponent {...wrappedComponentProps} />
    );
  };
}
